import { render, staticRenderFns } from "./junction-box-details-form.component.vue?vue&type=template&id=34c5710e"
import script from "./junction-box-details-form.component.ts?vue&type=script&lang=ts&external"
export * from "./junction-box-details-form.component.ts?vue&type=script&lang=ts&external"
import style0 from "./junction-box-details-form.component.vue?vue&type=style&index=0&id=34c5710e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports